import React from 'react';
import Styled from './styled';
import Medium from '../../assets/mail.svg';
import Telegram from '../../assets/telegram.svg';
import Twitter from '../../assets/twitter.svg';


const Footer = () => {
  return (
    <Styled.Wrapper>
      <Styled.Socials>
        <Styled.Social href="https://t.me/roobee_chat" target="_blank">
          <Styled.Icon src={Telegram} />
        </Styled.Social>
        <Styled.Social href="https://twitter.com/roobee_invest" target="_blank">
          <Styled.Icon src={Twitter} />
        </Styled.Social>
        <Styled.Social href="https://medium.com/roobee-invest" target="_blank">
          <Styled.Icon src={Medium} />
        </Styled.Social>
      </Styled.Socials>
      <Styled.Links>
        <Styled.Link download href="/docs/cookies_policy.pdf">Privacy Policy</Styled.Link>
        <Styled.Link download href="/docs/terms_of_use.pdf">Terms of Service</Styled.Link>
      </Styled.Links>
      <Styled.Copyright>© 2022 Roobee, All Rights Reserved.</Styled.Copyright>
    </Styled.Wrapper>
  );
};

export default Footer;
